import { render } from "./ServiceRequestCard.vue?vue&type=template&id=819fa16e&scoped=true"
import script from "./ServiceRequestCard.vue?vue&type=script&lang=js"
export * from "./ServiceRequestCard.vue?vue&type=script&lang=js"

import "./ServiceRequestCard.vue?vue&type=style&index=0&id=819fa16e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-819fa16e"]])

export default __exports__